import React from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMMessageView from './SMMessageView';
import SMOReservationView from 'components/dashboard/owners/reservations/SMOReservationView';
import SMUReservationView from 'components/dashboard/users/reservations/SMUReservationView';

class SMReservationContainerView extends React.Component {

  render() {
    return (
      <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
        <SMMessageView
          isOwner={this.props.isOwner}
          isCurrentView={this.props.isMessageView}
          reservation={this.props.reservation}
          delegate={this.props.delegate}
          display={this.props.display}
          rowIndex={this.props.rowIndex} />
        {(()=>{
          if (this.props.isOwner) {
            return <SMOReservationView
              isCurrentView={!this.props.isMessageView}
              reservation={this.props.reservation}
              shouldShowReview={this.props.shouldShowReview}
              display={this.props.display}
              delegate={this.props.delegate}
              rowIndex={this.props.rowIndex} />;
          } else {
            return <SMUReservationView
              currentUser={this.props.user}
              isCurrentView={!this.props.isMessageView}
              reservation={this.props.reservation}
              shouldShowReview={this.props.shouldShowReview}
              display={this.props.display}
              delegate={this.props.delegate}
              rowIndex={this.props.rowIndex} />;
          }
        })()}
      </CSSTransitionGroup>
    );
  }
}
SMReservationContainerView.propTypes = {
  isMessageView: PropTypes.bool.isRequired,
  isOwner: PropTypes.bool.isRequired,
};
export default SMReservationContainerView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationContainerView.jsx